<template>
    <li class="nav-item dropdown" id="call-history-menu-item" v-loading="isLoading" v-if="messages.length">
        <audio id="audio_message" src="/sounds/message.mp3"></audio>
        <a class="nav-icon dropdown-toggle" href="#" id="unreadChatMessages" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="position-relative">
                <MessageSquareIcon class="chat-icon animate" />
                <span v-if="messages.length" class="badge badge-primary counter">{{messages.length}}</span>
            </div>
        </a>
        <div v-loading="isLoading" class="dropdown-menu dropdown-menu-lg dropdown-menu-right py-0" aria-labelledby="alertsRemindersExpired">
            <form action="">
                <div class="dropdown-menu-header">
                    <a @click="readAll" class="text-muted">Прочитать всё</a>
                </div>
                <div class="list-group">
                    <div class="list-group-item" v-for="m in messages_prepared">
                        <div class="row no-gutters align-items-center">
                            <div class="col-6 font-weight-bold">
                                Заявка <router-link :to="{name: 'request', params: {id: m.request_id}}">№{{m.request_id}}</router-link>
<!--                                <span class="small text-muted d-block">{{remind.user.name}}</span>-->
                            </div>
                            <div class="col-6 text-right"><span class="small text-muted">{{m.from_now}}</span></div>
                            <div class="col-12 py-1">
                                <p class="">
                                    {{m.text ? (m.text.length > 100 ? m.text.slice(0, 100) + '...' : m.text) : ''}} {{m.attachments ? '+ Вложение' : ''}}
                                </p>
                            </div>
                            <div class="col-6 text-center"><router-link class="text-muted small" :to="{name: 'request', params: {id: m.request_id}}">Перейти</router-link></div>
                            <div class="col-6 text-center"><a @click="read(m.id)" class="text-muted small">Прочитать</a></div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    </li>
</template>

<script>
import fa from "element-ui/src/locale/lang/fa";
import {MessageSquareIcon} from "vue-feather-icons";

export default {
    name: "UnreadBLock",
    components: {MessageSquareIcon},
    data: () => ({
        messages: [],
        isLoading: false,
    }),
    mounted() {
        let self = this;
        Echo.private('user.' + this.$store.getters['auth/user'].id)
            .listen('.chat.message.created', function (e) {
                self.fetch();
                try {audio_message.play();} catch (e) {}
            })
            .listen('.chat.message.read', function (e) {
                self.fetch();
            });
        this.fetch();
    },
    beforeDestroy() {
        Echo.leave('user.' + this.$store.getters['auth/user'].id);
    },
    computed: {
        messages_prepared() {
            return this.messages.map(function (v) {
               v.from_now = moment(v.created_at).fromNow();
               return v;
            });
        }
    },
    methods: {
        fetch() {
            let self = this;
            this.isLoading = true;
            axios.get('/api/chats/unread')
                .then(r => {
                    self.messages = r.data;
                    self.isLoading = false;
                })
        },
        read(id) {
            let self = this;
            axios.get('/api/chats/read/' + id)
                .then(r => {
                    self.fetch();
                })
        },
        readAll() {
            let self = this;
            axios.post('/api/chats/readBatch', {
                ids: _.map(this.messages, 'id')
            })
                .then(r => {
                    self.fetch();
                })
        }
    }
}

</script>

<style lang="scss" scoped>
#unreadChatMessages .counter {
    font-size: 0.8rem;
    position: absolute;
    top: 2px;
    left: 10px;
    padding: 3px;
}

.chat-icon {
    border-radius: 50%;
    &.animate {
        transition: .3s;
        -webkit-animation: hoverBlueWave linear 1s infinite;
        animation: hoverBlueWave linear 1.5s infinite;
    }
}
</style>
